export default "__VITE_ASSET__DMp1I5aP__"